import { render, staticRenderFns } from "./offer_admin_discount.vue?vue&type=template&id=647567d1&"
import script from "./offer_admin_discount.vue?vue&type=script&lang=js&"
export * from "./offer_admin_discount.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports